export enum EIntervaloRepeticao {
    Semanal = 1,
    Quinzenal = 2,
    Mensal = 3,
    Bimestral = 4,
    Trimestral = 5,
    Semestral = 6,
    Anual = 7,
}
